// extracted by mini-css-extract-plugin
module.exports = {"error":"ArrayErrorsComponent_error__3Ziqb"};